import { Fragment } from 'react';
import WeeklyTrafficCard from '../../../components/dashboard/traffic/WeeklyTrafficCard';
import TrafficCard from '../../../components/dashboard/traffic/TrafficCard';
import WeekTrafficPieCard from '../../../components/dashboard/traffic/WeekTrafficPieCard';
import WeeklySummaryCard from '../../../components/dashboard/traffic/WeeklySummaryCard';
import DayHourSummaryCard from '../../../components/dashboard/traffic/DayHourSummaryCard';
import TrafficBarCard from '../../../components/dashboard/traffic/TrafficBarCard';


interface TrafficAnalyticsByWeekProps {
    geolocation?: boolean;
}

export default function TrafficAnalyticsByWeek({ geolocation }: TrafficAnalyticsByWeekProps) {

    return (
        <Fragment>
            <WeeklyTrafficCard />

            <WeeklySummaryCard />

            <TrafficBarCard />
            
            <TrafficCard />

            <WeekTrafficPieCard />

            <DayHourSummaryCard />

        </Fragment>
    )
}